import { LocationIncon } from '@/Common/Icons/Location';
import { CustomCascader } from '../CustomCascader';
import { ModalComponentV1 } from '../ModalComponentV1';
import styles from './index.module.css';
import { CityContext } from '@/context/cityContext';
import { useContext } from 'react';
import { LanguageContext } from '@/context/languageContext';
import { SIZE_OF_CITY } from '@/helpers/constants';

export const RestrictionComponentModal = () => {
  const { t } = useContext(LanguageContext);
  const {
    choosenCity,
    treeDataCountry,
    treeDataCountryLoading,
    setChoosenCity,
    setCityId,
    isRestrictionOpen,
    setIsRestrictionOpen,
  } = useContext(CityContext);

  const handleCascaderChange = (value: string[]) => {
    setChoosenCity(value);
    if (value.length > 0) {
      setCityId(+value[value.length - 1]);
    }
    setIsRestrictionOpen(false);
  };

  return (
    <ModalComponentV1
      title={t('ChooseLocation')}
      isOpen={isRestrictionOpen}
      onClose={() => {
        setIsRestrictionOpen(false);
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          marginTop: 20,
          justifyContent: 'center',
        }}
      >
        <CustomCascader
          displayRender={(label) => label.join(', ')}
          loading={treeDataCountryLoading}
          expandTrigger="hover"
          allowClear={false}
          size="large"
          style={{ width: '100%' }}
          className={styles.itemsSelector}
          prefix={<LocationIncon />}
          value={choosenCity}
          placeholder={t('chLocation')}
          options={treeDataCountry}
          expandIcon={
            <img
              src={'/assets/svg/CaretRight.svg'}
              alt="rightIcon"
              className={styles.arrowSpacing}
            />
          }
          onClick={() => {
            const menus = document.querySelector('.ant-cascader-menus');
            if (menus) {
              const allMenus = menus.querySelectorAll('[role="menu"]');
              allMenus[allMenus.length - 1]?.scroll({ top: 0 });
            }
          }}
          onChange={handleCascaderChange}
          classNames={{
            popup: { root: styles.popup },
          }}
          getPopupContainer={(props) => {
            if (!props?.querySelectorAll) return props;
            const menus = props.querySelectorAll('.ant-cascader-menu');
            if (!menus.length) return props;
            menus.forEach((v) => {
              v.style.overflow = 'auto';
              const sizeOfList = v.querySelectorAll('li').length;
              const mainHeight = sizeOfList * SIZE_OF_CITY;

              const list = v.querySelectorAll('li')[0];
              const isEmpty =
                list.getAttribute('data-path-key') === '__EMPTY__';

              if (isEmpty) {
                v.style.height = `100px`;
                return;
              }

              const availableHeight = window.innerHeight / 2 - 150;
              if (availableHeight < mainHeight) {
                v.style.setProperty(
                  'height',
                  `${availableHeight}px`,
                  'important'
                );
              } else {
                v.style.setProperty('height', `${mainHeight}px`, 'important');
              }
            });
            return props;
          }}
        />{' '}
      </div>
    </ModalComponentV1>
  );
};
